import type { ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material/styles'
import { Card, CardContent, Stack } from '@mui/material'
import ClimateSectionTitle from './ClimateSectionTitle'

type ClimateMetricCardProps = {
  title: string
  subtitle?: string
  children: ReactNode
  variant?: 'elevation' | 'outlined'
  sx?: SxProps<Theme>
  contentSx?: SxProps<Theme>
  stackSpacing?: number
}

const ClimateMetricCard = ({
  title,
  subtitle,
  children,
  variant = 'outlined',
  sx,
  contentSx,
  stackSpacing = 1.25,
}: ClimateMetricCardProps) => {
  const cardSx = [{ height: '100%' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]
  const mergedContentSx = Array.isArray(contentSx) ? contentSx : contentSx ? [contentSx] : []

  return (
    <Card variant={variant} sx={cardSx}>
      <CardContent sx={mergedContentSx}>
        <Stack spacing={stackSpacing}>
          <ClimateSectionTitle title={title} subtitle={subtitle} />
          {children}
        </Stack>
      </CardContent>
    </Card>
  )
}

export default ClimateMetricCard
